import { useRecoilValue } from 'recoil';
import { useState, useRef } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import Icon from '@mui/material/Icon';

import { ThemedLinkButton } from '@Components/MuiWrappers/Button';
import { ThemedBox } from '@Components/MuiWrappers/ThemedBox';

import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';

const AuctionListingGroup = (props) => {

    const theme = useRecoilValue(atoms.muiThemes);
    const returnFocusRef = useRef(null);       

    const [showMoreInfoMessage, setShowMoreInfoMessage] = useState(false);

    return (
        <ThemeProvider theme={(!theme.isHostedSite && theme.mainMode == "dark") ? theme.darkTheme : theme.lightTheme}>
            <ThemedBox>
                <div className='dealer-contact'>
                    <div class='detail-grouped-auction-listings-box'>
                        <div class='detail-grouped-auction-listings-box__header'>                            
                            <h3 class='detail-grouped-auction-listings-box__heading'>{translator.translate('sandhills.tradepubwebsite.mvc.auctiongrouplistings')}</h3>
                            <ThemedLinkButton variant='text' size='small' ref={returnFocusRef} className='detail-grouped-auction-listings-box__more-info' onClick={() => setShowMoreInfoMessage(showMoreInfo => !showMoreInfo)} sx={{ fontWeight: 'normal', color: 'inherit' }}>
                                {translator.translate('sandhills.tradepubwebsite.mvc.moreinfo')}
                                <Icon baseClassName='fas' className='fa-info-circle detail-grouped-auction-listings-box__more-info-icon' />
                            </ThemedLinkButton>                            
                        </div>
                        <div class='detail-grouped-auction-listings-box__links'>
                            <ul>
                                {props.AuctionListingGroupListings.map((listing, index) => (
                                    <li key={index}>
                                        <a href={listing.URL}>{listing.LotNumber}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {showMoreInfoMessage &&
                            <div >
                                <br />
                                <p>{translator.translate('sandhills.tradepubwebsite.mvc.auctiongroupblurb')}</p>                                    
                            </div>
                        }                        

                        {props.showGroupExtensionNote &&
                            <div class='group-extension-note'>
                                {translator.translate('sandhills.tradepubwebsite.mvc.auctiongroupnote')}
                            </div>
                        }
                    </div>
                </div>
            </ThemedBox>
        </ThemeProvider>
    );
};

export default AuctionListingGroup;